import React, { useContext, useEffect, useState } from 'react'
// import logo from '../../images/Circle.gif'
// import darklogo from '../../images/dark logo.png'
// import companyName from '../../images/Shift.png'
import { handleSubmission, submission } from '../../Auth'
import { BASE_URL } from '../../BaseURL'
import SignUpSchema from '../../validations/SignupValidation'
import { useNavigate } from 'react-router-dom'
import { showPassword } from '../../utils/ShowPassword'
import { clearInputs } from '../../utils/ClearInputs'
import { themeContext } from '../../contexts/theme_context/ThemeContext'

export default function Signup() {
  let navto = useNavigate()
  let [loading, setLoading] = useState(false)
  let [err, setErr] = useState({})
  let { webtheme } = useContext(themeContext)
  const validation = (submission, e, obj, url, setErr, navto, router, setLoading) => {
    e.preventDefault()
    let result = SignUpSchema.validate(obj, { abortEarly: false })
    clearInputs(obj)
    setErr({})
    let err = {}
    if (result.error) {
      for (let i of result.error.details) {
        let error = i.message.split(' ')[0].replaceAll('"', '')
        err[error] = i.message
      }
    }
    let confirm = isPasswordConfirmed()
    for (let i of Object.keys(err)) {
      let id = i + 'p'
      document.getElementById(id).innerText = err[i].replaceAll('"', '').replaceAll('_', ' ') + ' .'
    }
    if (confirm) {
      submission(e, obj, url, setErr, navto, router, setLoading)

    }
  }
  useEffect(() => {
    for (let i of Object.keys(err)) {
      let id = i + 'p'
      document.getElementById(id).innerText = err[i]
    }
  }, [err])
  const isPasswordConfirmed = () => {
    document.getElementById('cpasswordp').innerText = ""
    let cpass = document.getElementById('cpassword').value;
    let pass = document.getElementById('password').value
    if (cpass != pass) {
      document.getElementById('cpasswordp').innerText = "Doesn't match password"
      return false
    }
    return true
  }


  let [showed, setShowed] = useState(`password`)
  let [user, setUser] = useState({ date_joined: new Date().toLocaleString() })

  useEffect(() => {
    isPasswordConfirmed()
  }, [])

  const logoSrc = webtheme === 'light' ? '/Wordmark/Shift Wordmark Black.svg' : '/Wordmark/Shift Wordmark White.svg';

  return (
    <div className='d-flex justify-content-center align-items-center py-3 mt-5  pt-5'>
      <div className={`${webtheme}-section-bg col-xl-5 col-lg-6 col-md-6 col-sm-10 col-xs-11 login-form rounded rounded-2 shadow shadow-sm`}>
        <div className={`d-flex align-items-center justify-content-center login-header-rounded ${webtheme}-header-bg py-3 w-100`}>
          <img src={logoSrc} className=' col-4 me-2' alt="Shift EV" />
        </div>
        <p id='date_joinedp'></p>
        <form action="" className='p-4' onSubmit={(e) => {
          e.preventDefault()

          validation(submission, e, user, BASE_URL + '/auth/users/', setErr, navto, 'vehicles', setLoading)
        }}>
          <div className='col-12 '>
            <div className='col-12 d-flex mb-3 flex-wrap'>
              <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="username" className={`${webtheme}-text fw-thin fs-7 ps-1`} >User Name</label>
                <input type="text" placeholder='User Name' id='username' name='username' className={`${webtheme}-text fs-7`} onChange={(e) => { handleSubmission(e.target, user, setUser) }} />
                <p className='text-danger fs-8 m-0' id='usernamep'></p>
              </div>

              <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="email" className={`${webtheme}-white fw-thin fs-7 ps-1`}>Email</label>
                <input type="email" placeholder='User Name' id='email' name='email' className={`${webtheme}-text fs-7`} onChange={(e) => { handleSubmission(e.target, user, setUser) }} />
                <p className='text-danger fs-8 m-0' id='emailp'></p>
              </div>
            </div>
            <div className='col-12 d-flex mb-3 flex-wrap'>
              <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="password" className={`${webtheme}-text  fw-thin fs-7 ps-1`}>Password</label>
                <input type={showed} placeholder='Password' id='password' name='password' onChange={(e) => { handleSubmission(e.target, user, setUser) }} className={`${webtheme}-text fs-7`} />
                <p className='text-danger fs-8 m-0' id='passwordp'></p>
              </div>         <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="cpassword" className={`${webtheme}-text fw-thin fs-7 ps-1`}>Confirm Password</label>
                <input type={showed} placeholder='Confirm Password' id='cpassword' name='cpassword' onChange={(e) => { }} className={`fs-7 ${webtheme}-text`} />
                <p className='text-danger fs-8 m-0' id='cpasswordp'></p>
              </div>
              <div className='d-flex align-items-center ps-2'>
                <input type="checkbox" id="show" name="show" value="show" className='fit-width me-1' onChange={() => { showPassword(showed, setShowed) }} />
                <label htmlFor="show" className={`fs-7 ${webtheme}-text text-nowrap`}>show password</label>
              </div>
            </div>
            <div className='col-12 d-flex mb-3 flex-wrap'>
              <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="first_name" className={`fw-thin fs-7 ps-1`} >First Name</label>
                <input type="text" placeholder='First Name' id='first_name' name='first_name' className={`fs-7 ${webtheme}-text`} onChange={(e) => { handleSubmission(e.target, user, setUser) }} />
                <p className='text-danger fs-8 m-0' id='first_namep'></p>
              </div>
              <div className='col-sm-6 col-xs-12 p-2'>
                <label htmlFor="last_name" className='text-white fw-thin fs-7 ps-1'>Last Name</label>
                <input type='text' placeholder='Last Name' id='last_name' name='last_name' onChange={(e) => { handleSubmission(e.target, user, setUser) }} className={`fs-7 ${webtheme}-text`} />
                <p className='text-danger fs-8 m-0' id='last_namep'></p>
              </div>
            </div>
          </div>
          <div>
            <p className={`${webtheme}-text fw-light p-2`}>Already have account? <span className='text-primary cursor' onClick={() => { navto('/login') }}>login</span></p>
          </div>
          <div className='d-flex justify-content-center w-100 '>
            {loading ?
              <button className='btn text-white btn-orange fs-7 py-2 col-md-3 col-sm-12 col-xs-12 text-nowrap text-center d-flex justify-content-center align-items-center ' disabled><i className="fa-solid fa-spinner fa-spin"></i></button>
              : <button className='btn text-white btn-orange fs-7 py-2 col-md-3 col-sm-12 col-xs-12 text-nowrap' onClick={() => {
              }}>Sign up</button>}


          </div>
        </form>
      </div >
    </div >
  )
}
